import { DOMAttributes, forwardRef, PropsWithChildren } from 'react'
import Styles from './ActionCard.module.scss'
import { Card } from 'components/DocRightRail/screens/AIAssistant/Card'
import cx from 'classnames'

interface Props extends DOMAttributes<HTMLDivElement> {
  className?: string
}

export const ActionCard = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, className, ...props }, fRef) => (
    <Card className={cx(Styles.card, className)} {...props} ref={fRef}>
      {children}
    </Card>
  ),
)
